module.exports = __webpack_public_path__ + "img/icon_safe.5128c980.png";